import * as Sentry from '@sentry/react'
import { Iterable } from 'immutable'
import { isEmpty } from 'lodash-es'

import { createSentryLogger, SentryLoggingSDK } from '@lyrahealth-inc/shared-app-logic/src/features/sentry/utils'

import { IS_SESSION_TIMER_DISABLED } from '../constants/appConstants'

export const LYRA_WEB_UI_LOG_CATEGORY = 'lyraWebErrors'

export enum LOG_CATEGORY {
  PROD_DEBUG = 'prod/lyraweb/debug',
  STAGING_DEBUG = 'staging/lyraweb/debug',
}

export const hasRole = (user: $TSFixMe, role: $TSFixMe) => {
  if (Iterable.isIterable(user)) {
    user = user.toJS()
  }
  if (!isEmpty(user) && !!user.roles) {
    let retVal = false

    for (let i = 0; i < user.roles.length; i++) {
      if (user.roles[i].role === role) {
        retVal = true
      }
    }

    return retVal
  }

  return false
}

export const logToSentry = createSentryLogger(Sentry as unknown as SentryLoggingSDK)

const onBeforeUnload = () => {
  localStorage.setItem(IS_SESSION_TIMER_DISABLED, JSON.stringify(false))
}

/**
 * Utility method to toggle the session timer on/off. This is done because a user can have a video session open and
 * in another tab they could get timed out which will log them out of the video session. To prevent this we stop
 * the session timer for all tabs when a video session is going on any of them.
 */
export const toggleIsSessionTimerDisabled = (isSessionTimerDisabled: boolean) => {
  removeEventListener('beforeunload', onBeforeUnload)
  if (isSessionTimerDisabled) {
    addEventListener('beforeunload', onBeforeUnload)
  }
  localStorage.setItem(IS_SESSION_TIMER_DISABLED, JSON.stringify(isSessionTimerDisabled))
}
